/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { trashPlansRoute } from '@jira/router-routes__advanced-roadmaps-spa-routes/src/trashPlansRoute.tsx';
import { TrashedPlansDirectory, LazyTrashedPlans } from './ui/plan-trash/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const trashPlansRouteEntry: Route = createEntry(trashPlansRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: TrashedPlansDirectory,
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalProductsSettings,
		menuId: MenuIdSettings,
	},

	resources: [...getNavigationResources(), navigationSidebarGlobalResource],
	forPaint: [LazyAtlassianNavigation, LazyTrashedPlans],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
